import { createSlice } from "@reduxjs/toolkit";

const insightDrawerSlice = createSlice({
  name: "insightDrawer",
  initialState: {
    isOpen: false,
    insightData: null,
  },
  reducers: {
    openInsightDrawer(state, action) {
      state.isOpen = true;
      state.insightData = action.payload;
    },
    closeInsightDrawer(state) {
      state.isOpen = false;
      state.insightData = null;
    },
  },
});

export const { openInsightDrawer, closeInsightDrawer } = insightDrawerSlice.actions;
export default insightDrawerSlice.reducer;
